import * as React from 'react'

function SvgCateReligion(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M19.983 2v17.697H8.865v2.294l-1.348-.797-1.35.798v-2.295h-.424A1.745 1.745 0 014 17.954V3.744C4 2.781 4.782 2 5.743 2h14.24zm-.75 14.856H4.75v1.098c0 .548.446.994.993.994h.425V18h2.697v.948h10.368v-2.092zm0-14.106H6.76v13.356h12.473V2.75zm-13.223 0h-.267a.994.994 0 00-.993.993v12.363h1.26V2.75zm7.471 2.738V7.61h2.198v1.495h-2.198v4.263h-1.495V9.105H9.788V7.61h2.198V5.488h1.495z" />
    </svg>
  )
}

export default SvgCateReligion
